import { CompoundCarEndpoint } from "@module/_core/infras/config/endpointUrl/compoundCar";

export class OrderEndpoint extends CompoundCarEndpoint {
    static getOrders = () => `${CompoundCarEndpoint.base}/v1/orders`;
    static checkInviterInformation = (phoneNumber: string) =>
        `${CompoundCarEndpoint.base}/v1/users/invitation-verification?phoneNumber=${phoneNumber}`;
    static checkInviterInformationByToken = (token: string, inviterPhoneNumber: string) =>
        `${CompoundCarEndpoint.base}/v1/users/invitation-verification/token?token=${encodeURIComponent(token)}&inviterPhoneNumber=${encodeURIComponent(inviterPhoneNumber)}`;
    static createOrder = () => `${CompoundCarEndpoint.base}/v1/orders`;
    static getOrderStatus = (orderId: string) => `${CompoundCarEndpoint.base}/v1/orders/${orderId}/status`;

    static createOrderV2 = () => `${CompoundCarEndpoint.base}/v2/orders`;
    static getOrderStatusV2 = (orderId: string, token: string) =>
        `${CompoundCarEndpoint.base}/v2/orders/${orderId}/status?token=${encodeURIComponent(token)}`;

    static getSubscriptionEndDate = (token: string) =>
        `${CompoundCarEndpoint.base}/v1/users/subscription/end-date?token=${encodeURIComponent(token)}`;
}
